import View from './SideSheetDeployPipeline';
import enhancer from './SideSheetDeployPipeline.enhancer';

const SideSheetDeployPipeline = enhancer(View);

export default SideSheetDeployPipeline;
